import React from 'react';
function ChevronLeft() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ChevronLeft;
